/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose'
import { useForm } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'

import ButtonClose from '../buttons/ButtonClose'
import ButtonSaveDraft from '../buttons/ButtonSaveDraft'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import Loading from '../Loading'

const ModalFeedback = ({ handleCloseModal }) => {
	const [isLoading, setIsLoading] = useState(false)
	const axiosPrivate = useAxiosPrivate()
	// eslint-disable-next-line no-unused-vars
	const [searchParams, setSearchParams] = useSearchParams()

	const {
		handleSubmit,
		register,
		formState: { errors }
	} = useForm()

	const sendFeedback = async data => {
		try {
			setIsLoading(true)

			await axiosPrivate.post('/POP_Feedback', data)

			Swal.fire({
				title: 'Success',
				text: 'Thank you for reaching out and providing us with valuable feedback',
				icon: 'success',
				confirmButtonText: 'Ok',
				willClose: () => {
					handleCloseModal()
					setSearchParams()
				}
			})
		} catch (err) {
			Swal.fire({
				title: 'Error!',
				text: 'Could not send your feedback at the moment, please try again later',
				icon: 'error',
				confirmButtonText: 'Ok'
			})
		} finally {
			setIsLoading(false)
		}
	}

	if (isLoading) return <Loading />

	return (
		<div className="modal-wrapper">
			<div className="modal-box md:w-9/12 lg:w-8/12 xl:w-6/12">
				<div className="modal-header">
					<h2 className="modal-title">Feedback Form</h2>

					<a onClick={handleCloseModal}>
						<IoMdClose size={30} />
					</a>
				</div>

				<div className="mt-3">
					<h3>
						We would love to hear your thoughts, suggestions, concerns or problems
						with anything so we can improve.
					</h3>
				</div>

				<form onSubmit={handleSubmit(sendFeedback)}>
					<div className="mt-5 grid grid-cols-1 gap-5">
						<div>
							<label>
								Feedback Type <sup className="text-red-500">*</sup>
							</label>
							<div className="flex flex-col items-baseline leading-loose md:flex-row">
								<label className="text-inherit">
									<input
										type="radio"
										value="reportErrors"
										{...register('feedbackType', {
											required: 'Please select feedback type'
										})}
									/>
									<span className="ml-2">Report Error</span>
								</label>
								<label className="text-inherit md:ml-5">
									<input
										type="radio"
										value="suggestions"
										{...register('feedbackType', {
											required: 'Please select feedback type'
										})}
									/>
									<span className="ml-2">Suggestions</span>
								</label>
								<label className="text-inherit md:ml-5">
									<input
										type="radio"
										value="questions"
										{...register('feedbackType', {
											required: 'Please select feedback type'
										})}
									/>
									<span className="ml-2">Questions</span>
								</label>
							</div>
							{errors.feedbackType && (
								<div className="text-red-500 text-xs mt-1">
									{errors.feedbackType.message}
								</div>
							)}
						</div>
						<div>
							<label>
								Describe Your Feedback <sup className="text-red-500">*</sup>
							</label>
							<textarea
								rows="5"
								{...register('feedbackData', {
									required: 'Please describe your feedback'
								})}
							></textarea>
							{errors.feedbackData && (
								<div className="text-red-500 text-xs mt-1">
									{errors.feedbackData.message}
								</div>
							)}
						</div>
					</div>

					<div className="btn-container mt-5">
						<ButtonSaveDraft type="submit" title="Send Feedback" />
						<ButtonClose onClick={handleCloseModal} title="Cancel" />
					</div>
				</form>
			</div>
		</div>
	)
}

export default ModalFeedback
